export enum OnboardingStatus {
	UNSUPPORTED_COUNTRY = 'UNSUPPORTED_COUNTRY',
	GLOBAL = 'GLOBAL',
	ONBOARDED = 'ONBOARDED',
	SIGNED_UP = 'SIGNED_UP',
	USER = 'USER',
	GLOBAL_CLICKED_CTA = 'GLOBAL_CLICKED_CTA',
}
